<script setup lang="ts">
export interface Step {
  title: string
  disabled: boolean
  description: string
}

const modelValue = defineModel<number>('modelValue')

defineProps<{
  steps: Step[]
}>()

const handleStep = (index: number, steps: Step[]) => {
  const previousStepsValid = steps.slice(0, index - 1).every((s) => !s.disabled)
  if (!previousStepsValid) return

  modelValue.value = index
}
</script>

<template>
  <nav aria-label="Progress">
    <ol class="space-y-4 md:flex md:space-x-8 md:space-y-0">
      <li v-for="(step, index) in steps" :key="step.title" class="md:flex-1">
        <button
          :class="[
            'group flex w-full flex-col border-l-4 py-2 pl-4 focus:outline-none md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4 cursor-pointer duration-300',
            {
              'border-primary': modelValue === index + 1,
              'border-border hover:border-foreground/20': modelValue !== index + 1,
              'pointer-events-none': step.disabled
            }
          ]"
          @click="handleStep(index + 1, steps)"
        >
          <span
            :class="[
              'text-xs font-semibold uppercase tracking-wide group-hover:text-primary duration-300',
              {
                'text-primary': modelValue === index + 1,
                'text-muted-foreground': modelValue !== index + 1
              }
            ]"
          >
            {{ step.title }}
          </span>
          <span class="text-sm font-medium">{{ step.description }}</span>
        </button>
      </li>
    </ol>
  </nav>
</template>
